import React, { useState, useEffect, useRef, useCallback } from "react";
import { Form } from "react-bootstrap";
import s from './customSelector.module.css';
import { ReactComponent as ArrowDown } from '../../../../../assets/icons/ArrowDown.svg';

export interface ICustomSelectorProps {
    selectedItem: string;
    onSelectItem: (item: string) => void;
    availableItems: string[];
    typeOfDowndrop: string;
}

export const CustomSelector: React.FC<ICustomSelectorProps> = ({
                                                                       selectedItem,
                                                                       onSelectItem,
                                                                       availableItems,
                                                                       typeOfDowndrop,
                                                                   }) => {
    const [searchTerm, setSearchTerm] = useState('');
    const [isOpen, setIsOpen] = useState(false);
    const wrapperRef = useRef<HTMLDivElement>(null);

    const handleItemSelect = useCallback((item: string, e: React.MouseEvent) => {
        e.preventDefault();
        e.stopPropagation();

        onSelectItem(item)
        setIsOpen(false);
    }, [onSelectItem]);

    const filteredItems = availableItems.filter(item =>
        item?.toLowerCase()?.includes(searchTerm.toLowerCase())
    );

    const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setSearchTerm(e.target.value);
    };

    const handleSearchClick = (e: React.MouseEvent) => {
        e.stopPropagation();
    };

    const handleToggleDropdown = (e: React.MouseEvent) => {
        e.preventDefault();
        e.stopPropagation();
        setIsOpen(!isOpen);
    };

    useEffect(() => {
        function handleClickOutside(event: MouseEvent) {
            if (wrapperRef.current && !wrapperRef.current.contains(event.target as Node)) {
                setIsOpen(false);
            }
        }

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    return (
        <div className={s.container} ref={wrapperRef}>
            <div
                className={`${s.selector} ${isOpen ? s.selectorOpen : ''}`}
                onClick={handleToggleDropdown}
            >
                <div className={s.selectorValue}>
                    {selectedItem.length > 0
                        ? `${selectedItem}`
                        : `Выберите ${typeOfDowndrop}`
                    }
                </div>
                <div className={s.arrowIcon}>
                    <ArrowDown/>
                </div>
            </div>

            {isOpen && (
                <div className={s.dropdown} onClick={(e) => e.stopPropagation()}>
                    <div className={s.searchContainer}>
                        <div className={s.searchWithButton}>
                            <Form.Control
                                type="text"
                                placeholder="Поиск"
                                value={searchTerm}
                                onChange={handleSearchChange}
                                onClick={handleSearchClick}
                                className={s.searchInput}
                                autoFocus
                            />
                        </div>
                    </div>

                    <div className={s.itemsList}>
                        {filteredItems.length > 0 ? (
                            filteredItems.map(item => (
                                <div
                                    key={item}
                                    className={`${s.materialItem} ${ item === selectedItem ? s.selected : ''}`}
                                    onClick={(e) => handleItemSelect(item, e)}
                                >
                                    <span className={s.materialName}>{item}</span>
                                    {item === selectedItem && (
                                        <span className={s.checkmark}>✓</span>
                                    )}
                                </div>

                            ))
                        ) : (
                            <div className={s.noMaterials}>
                                {searchTerm ? 'Не найдено' : 'Не загружено'}
                            </div>
                        )}
                    </div>
                </div>
            )}
        </div>
    );
};